import React from "react";

interface ItemListProps<T> {
  items: Record<string, T>;
  renderItem: (name: string, itemData: T, index: number) => React.ReactNode;
  separator?: string;
  lastSeparator?: string;
}

function ItemList<T>({
  items,
  renderItem,
  separator = ", ",
  lastSeparator = " and ",
}: ItemListProps<T>) {
  const entries = Object.entries(items);
  const count = entries.length;

  if (count === 0) {
    return null;
  }

  return (
    <>
      {entries.map(([name, itemData], i) => {
        const isLast = i === count - 1;
        let currentSeparator = "";
        if (i > 0) {
          currentSeparator = isLast ? lastSeparator : separator;
        }

        return (
          <React.Fragment key={name}>
            {currentSeparator}
            {renderItem(name, itemData, i)}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default ItemList;
